<div class="main">
  <div ngStyle.xs="padding-inline:0" fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="10"
    fxLayoutGap.xs="0" fxLayoutGap.sm="0" class="adver main_ads ">
    <!-- <div fxFlexAlign="center" class="ad_div hide_ad_mobile" fxFlex.lg="100" fxFlex.xl="100" fxFlex.md="100"
      fxFlex.xs="100" fxFlex.sm="100" fxLayoutAlign="center">
      <a href="https://bit.ly/4dPbkZD" target="_blank" rel="noopener">
        <img loading="lazy" style="display: block; width: 100%;   margin:auto"
          src="https://cdn.newsfirst.lk/advertisements/05-09-2024/720X90-%20sirasa%20floating.jpg" alt="" /></a>
    </div>

    <div fxFlexAlign="center" class="ad_div hide_ad_lap" fxFlex.lg="50" fxFlex.xl="50" fxFlex.md="50" fxFlex.xs="100"
      fxFlex.sm="100" fxLayoutAlign="center">
      <a href="https://bit.ly/4dPbkZD" target="_blank" rel="noopener">
        <img loading="lazy" style="display: block; width: 100%;   margin:auto"
          src="https://cdn.newsfirst.lk/advertisements/05-09-2024/720X90-%20sirasa%20floating.jpg" alt="" /></a>
    </div> -->
  </div>
  <div style="height: 100px; background-color: #1C1C1C; width: 100%;color: aliceblue;position: relative;">
    <div class="header_div">
      <div>
        சமீபத்திய செய்திகள்
      </div>
    </div>
  </div>

  <div class="padding">
    <!-- =============================================== -->

    <!-- <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver"
      style="margin-bottom: 30px;">

      <div fxFlexAlign="center" class="ad_div  hide_ad_lap" fxFlex="75" fxFlex.xs="100" fxFlex.sm="100"
        fxLayoutAlign="center">
        <a href="https://news1st.lk/3MS0FRU" target="_blank" rel="noopener">
          <img loading="lazy" style=" margin: auto;height:100% !important; width: 100%;  "
            src="https://cdn.newsfirst.lk/advertisements/14-11-2024/Gen%20Election%202024%20H.jpg" alt="" />
        </a>
      </div>

      <div fxFlexAlign="center" class="ad_div hide_ad_mobile" fxFlex="75" fxFlex.xs="100" fxFlex.sm="100"
        fxLayoutAlign="center">
        <a href="https://news1st.lk/3MS0FRU" target="_blank" rel="noopener">
          <img loading="lazy" style=" margin: auto;height:100% !important; width: 100%;  "
            src="https://cdn.newsfirst.lk/advertisements/14-11-2024/Gen%20Election%202024%20M.jpg" alt="" />
        </a>

      </div>

    </div>

    <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="10" fxLayoutGap.xs="10"
      fxLayoutGap.sm="10" class="adver  ">
      <div fxFlexAlign="center" class="ad_div  hide_ad_lap_new" fxFlex="100" fxFlex.xs="100" fxFlex.sm="100"
        fxLayoutAlign="center">
        <a href="https://news1st.lk/3MS0FRU" target="_blank" rel="noopener" style="width: 100%;">
          <iframe style="width: 100% !important;" src="https://election-graph-tv-new.pages.dev"
            frameborder="0"></iframe>
        </a>
      </div>
    </div> -->


    <!-- =============================================== -->
    <div fxLayout="row" fxLayoutGap="10" style="margin-top: 50px;" fxLayout.sm="column" fxLayout.xs="column">
      <div fxFlex.lg="80" fxFlex.xl="80" fxFlex.md="80" fxFlex.sm="100" fxFlex.xs="100" fxLayout="column">

        <div class="local_news_main">
          <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column">
            <div fxFlex="60" *ngFor="let item of latestPost | slice:0:1; let i=index" style="cursor: pointer;"
              (click)="postId(item.id)">
              <div class="border-right-local">
                <div>
                  <a href="/{{item.post_url}}">
                    <div class="local_img_div" style="position: relative;">
                      <div *ngIf="item.video_post!=null" style="width: 70px;height:70px;" class="video_play_main ">
                        <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                      </div>
                      <img loading="lazy" style="width: 100%;" [src]="item.images.large_tile_image"
                        alt={{item.short_title}}>
                    </div>
                    <h1 class="top_stories_header" style="height: auto !important;">
                      {{item.short_title}}
                    </h1>
                    <div>
                      <p class="top_stories_details"
                        [innerHtml]="replaceString(item.excerpt.rendered).substring(0,150)+'...'"> </p>
                    </div>
                    <div style="margin-top: 40px;">
                      <div fxFlex="60" class="read_more" id="testID">மேலும் வாசிக்க</div>
                      <!-- <div fxFlex="40" fxLayoutAlign="end" class="read_more">share</div> -->
                    </div>
                  </a>
                </div>
              </div>

            </div>
            <div fxFlex="40" class="local_news">
              <!-- Local News  -->
              <div *ngFor="let item of latestPost | slice:1:5; let i=index" style="cursor: pointer;"
                (click)="postId(item.id)">
                <a href="/{{item.post_url}}">
                  <div fxLayout="row" style="width: 100%;height: max-content;    margin-bottom: 10px;" fxLayoutGap="10">
                    <div fxFlex="30" style=" height: 100%;position: relative;">
                      <div *ngIf="item.video_post!=null" style="width: 70px;height:70px;" class="video_play_main ">
                        <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                      </div>
                      <img loading="lazy" style="height: 90px; object-fit: cover;" width="100%"
                        [src]="item.images.large_tile_image" alt={{item.short_title}}>
                    </div>
                    <div fxFlex="70">
                      <div class="time_date">{{item.date.split("T")[0]}} | {{item.date.split("T")[1].split(".")[0]}}
                      </div>
                      <h4 class="top_stories_sub_header">{{item.short_title}}</h4>
                      <div class="top_stories_sub_detail" style="font-size: 12px;"
                        [innerHtml]="replaceString(item.content.rendered).substring(0,55)+'...'"> </div>
                    </div>
                  </div>
                </a>
                <mat-divider style="margin-bottom: 20px;"></mat-divider>

              </div>
              <!-- <div style="position: relative;">
                <div style="position: relative;
                width: max-content;
                height: max-content;
                top: 0;
                bottom: 0;
                margin: auto;" class="read_more">Read more</div>
              </div> -->

            </div>
          </div>
        </div>
      </div>

      <!-- ======================================== -->
      <div fxFlex="20" fxFlex.xs="100" fxFlex.sm="100">
        <div style="position: relative; width: 100%;margin-bottom: 10px;">
          <div style="margin-bottom: 10px;">
            <!-- <iframe class="hide_ad_lap_n" style="margin: auto;    justify-content: end; overflow: hidden; width: 100%;"
              height="330"
              src="https://cdn.newsfirst.lk/advertisements/09-04-2024/Combo%20Pack%20Tam_330x330/index.html"
              frameborder="0"></iframe>
            <iframe class="hide_ad_mobile_n" style="margin: auto;   justify-content: end; overflow: hidden; "
              src="https://cdn.newsfirst.lk/advertisements/09-04-2024/Combo%20Pack%20Tam_300x70/index.html"
              frameborder="0"></iframe> -->
            <!-- <iframe style="margin: auto;    justify-content: end; overflow: hidden; width: 100%;" height="330"
                src="https://cdn.newsfirst.lk/advertisements/31-10-2024/330x330%20(2)/index.html"
                frameborder="0"></iframe> -->

                <a href="https://www.mobitel.lk/max-1598" target="_blank">
                  <img
                  style="max-width: 100%;    margin: auto;  display: flex;  justify-content: end;margin-bottom: 10px; max-width: 300px; "
                    src="https://cdn.newsfirst.lk/advertisements/13-05-2025/330_330%20-%20T.png" alt="">
                </a>
            <!-- <a href=" https://www.mobitel.lk/pocket-pack" target="_blank">
              <img style="max-width: 100%;    margin: auto;  display: flex;  justify-content: end;  "
                src="https://cdn.newsfirst.lk/advertisements/01-10-2024/mobitel_330x330.gif" alt="">
            </a> -->
            <a href="https://news1st.lk/4etYkbj" target="_blank">
              <img
                style="max-width: 100%; max-height: 300px;   margin: auto;  display: flex;  justify-content: end;margin-bottom: 10px;  "
                src="https://cdn.newsfirst.lk/election/advertisment/250x250--1.jpg" alt="">
            </a>


          </div>


        </div>
        <div fxFlexAlign="center" fxLayoutAlign="center" style=" margin-bottom: 10px;  ">
          <ins class="adsbygoogle" style="display:inline-block;width:300px;height:250px;"
            data-ad-client="ca-pub-5432073672371728" data-ad-slot="3155889414"></ins>
          <!-- <a href="https://bit.ly/42XNEgc" target="_blank">
            <img style="max-width: 100%;    margin: auto;  display: flex;  justify-content: end;  "
              src="https://cdn.newsfirst.lk/advertisements/22-05-2023/AnleneHaiyak.gif" alt="">
          </a> -->
        </div>

        <!-- <div class="mobile_ads" fxFlexAlign="center" fxLayoutAlign="center"
          style="height: 250px;margin-bottom: 10px;  ">
          <div id="block_4921" style="    width: 100%;  overflow: hidden;"></div>


        </div> -->
        <div class="mobile_ads" fxFlexAlign="center" fxLayoutAlign="center"
          style="height: 250px;margin-bottom: 10px;  ">
          <div id="block_4405" style="width: 100%;  overflow: hidden;"></div>
        </div>

      </div>
      <!-- ======================================== -->
    </div>
    <!-- ======================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="20" style="margin-top: 20px"
      class="adver">
      <div fxFlexAlign="center" class="ad_div" fxFlex.lg="50" fxFlex.xs="100" fxFlex.sm="100" fxLayoutAlign="center">
        <div class="ads_lap_hide" id="block_4404" style="max-height:90px !important;width: 100% !important;"></div>
        <div class="ads_mobile_hide" id="block_5077"></div>

      </div>
    </div>
    <!-- ======================================== -->
    <!-- ====================================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver"
      style=" margin-top: 10px;">
      <div fxFlexAlign="center" class="ad_div" fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center">
        <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-5432073672371728"
          data-ad-slot="1155259484" data-ad-format="auto" data-full-width-responsive="true"></ins>

      </div>
      <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
        ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
        <ins class="adsbygoogle" style="display:inline-block;width:920px;height:90px"
          data-ad-client="ca-pub-5432073672371728" data-ad-slot="7081168074"></ins>

      </div> -->
    </div>
    <!-- ====================================================== -->

    <div class="lap_news_div">
      <div fxLayout="row" style="margin-top: 50px;" fxLayoutGap="10" fxLayout.sm="column" fxLayout.xs="column">
        <div fxFlex.lg="80" fxFlex.xl="80" fxFlex.md="80" fxFlex.sm="100" fxFlex.xs="100" fxLayout="column">
          <div>
            <div class="black_header">
              <div class="black_header_title display-flex">சமீபத்திய</div>
            </div>
            <div class="local_news_main">
              <div>

                <div *ngFor="let item of latestPostPagination| paginate: config  ; let i=index" style="cursor: pointer;"
                  (click)="postId(item.id)">
                  <a href="/{{item.post_url}}">
                    <div fxLayout="row" fxLayoutGap="10">
                      <div fxFlex="25" style="height: max-content;position: relative; ">
                        <div *ngIf="item.video_post!=null" style="width: 70px;height:70px;" class="video_play_main ">
                          <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                        </div>
                        <img loading="lazy" style="width: 100%;" src="{{item.images.mini_tile_image}}"
                          alt={{item.short_title}}>
                      </div>
                      <div fxFlex="75">
                        <div class="time_date">{{item.date.split("T")[0]}} | {{item.date.split("T")[1].split(".")[0]}}
                        </div>
                        <h2 class="local_news_sub_header">{{item.short_title}}</h2>
                        <div class="top_stories_sub_detail"
                          [innerHtml]="replaceString(item.excerpt.rendered).substring(0,300)+'...'">
                          <!-- <p style="font-size: 15px;" class="top_stories_sub_detail">three children who are already
                  infected...</p> -->
                        </div>
                      </div>

                    </div>
                  </a>
                  <mat-divider style="margin-block: 15px;"></mat-divider>

                </div>
              </div>



              <!-- <mat-paginator  [length]="row_count" [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Select page"
          (page)="paginatePage($event)" aria-label="Select page">
        </mat-paginator> -->

              <div class="display-flex">
                <pagination-controls class="pagination" [maxSize]="maxSize" [directionLinks]="directionLinks"
                  [autoHide]="autoHide" [responsive]="responsive" [previousLabel]="labels.previousLabel"
                  [nextLabel]="labels.nextLabel" [screenReaderPaginationLabel]="labels.screenReaderPaginationLabel"
                  [screenReaderPageLabel]="labels.screenReaderPageLabel"
                  [screenReaderCurrentLabel]="labels.screenReaderCurrentLabel" (pageChange)="pageChanged($event)">
                </pagination-controls>
              </div>

            </div>
          </div>

        </div>

        <div fxFlex.lg="20" fxFlex.xl="20" fxFlex.sm="100" fxFlex.md="100" fxFlex.xs="100" fxLayout="column">
          <!-- =============================================== -->
          <div style="margin-top: 10px;">
            <ins class="adsbygoogle" style="display:block;max-width: 300px;margin-bottom: 10px;"
              data-ad-client="ca-pub-5432073672371728" data-ad-slot="5365967236" data-ad-format="auto"
              data-full-width-responsive="true"></ins>

            <ins class="adsbygoogle" style="display:block;max-width: 300px;" data-ad-client="ca-pub-5432073672371728"
              data-ad-slot="5365967236" data-ad-format="auto" data-full-width-responsive="true"></ins>
          </div>
          <!-- =============================================== -->
        </div>
      </div>
    </div>

    <div class="mobile_news_div">
      <div fxLayout="row" style="margin-top: 50px;" fxLayoutGap="10" fxLayout.sm="column" fxLayout.xs="column">
        <div fxFlex.lg="80" fxFlex.xl="80" fxFlex.md="80" fxFlex.sm="100" fxFlex.xs="100" fxLayout="column">
          <div>
            <div class="black_header">
              <h2 class="black_header_title display-flex">சமீபத்திய</h2>
            </div>
            <div style="margin-bottom: 20px; cursor: pointer;" class="local_news_main"
              *ngFor="let item of latestPostPagination  let i=index" (click)="postId(item.id)">
              <a href="/{{item.post_url}}">
                <div style="position: relative;">
                  <div *ngIf="item.video_post!=null" style="width: 70px;height:70px;" class="video_play_main ">
                    <img src="https://cdn.newsfirst.lk/assets/play.png" alt="">
                  </div>
                  <img loading="lazy" style="width: 100%;" [src]="item.images.mobile_banner" alt={{item.short_title}}>
                </div>
                <div style="padding: 20px;">

                  <h1 class="top_stories_header">
                    {{item.short_title}}
                  </h1>
                  <div class="top_stories_details" style="height: 120px;overflow: hidden;"
                    [innerHTML]="replaceString(item.excerpt.rendered).substring(0,300)">
                    <!-- <p style="" class="top_stories_details">{{item.content.rendered.substring(0,400)}}</p> -->
                  </div>
                  <div style="margin-top: 40px;">
                    <div fxFlex="60" class="read_more">மேலும் வாசிக்க</div>
                    <!-- <div fxFlex="40" fxLayoutAlign="end" class="read_more">share</div> -->
                  </div>


                </div>
              </a>
            </div>
          </div>
        </div>

        <div fxFlex.lg="20" fxFlex.xl="20" fxFlex.sm="100" fxFlex.md="100" fxFlex.xs="100" fxLayout="column">
          <!-- =============================================== -->
          <div style="margin-top: 10px;">
            <ins class="adsbygoogle" style="display:block;max-width: 300px;margin-bottom: 10px;"
              data-ad-client="ca-pub-5432073672371728" data-ad-slot="5365967236" data-ad-format="auto"
              data-full-width-responsive="true"></ins>

            <ins class="adsbygoogle" style="display:block;max-width: 300px;" data-ad-client="ca-pub-5432073672371728"
              data-ad-slot="5365967236" data-ad-format="auto" data-full-width-responsive="true"></ins>
          </div>
          <!-- =============================================== -->
        </div>

      </div>
    </div>

    <!-- ====================================================== -->
    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="10" class="adver"
      style=" margin-top: 10px;">
      <div fxFlexAlign="center" class="ad_div" fxFlex="100" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center">
        <ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-5432073672371728"
          data-ad-slot="1155259484" data-ad-format="auto" data-full-width-responsive="true"></ins>

      </div>
      <!-- <div fxFlexAlign="center" class="ad_div" fxFlex="50" fxFlex.sm="100" fxFlex.xs="100" fxLayoutAlign="center"
        ngStyle.xs="width: 330px;" ngStyle.sm="width: 330px;">
        <ins class="adsbygoogle" style="display:inline-block;width:920px;height:90px"
          data-ad-client="ca-pub-5432073672371728" data-ad-slot="7081168074"></ins>

      </div> -->
    </div>
    <!-- ====================================================== -->
  </div>

</div>
